import React from 'react';
import { styled } from '@mui/material/styles';
import { Tooltip as MuiTooltip } from '@mui/material';

const CustomTooltip = styled(({ className, ...props }) => (
  <MuiTooltip {...props} classes={{ popper: className }} />
))(({ theme, maxWidth = '350px' }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: '#333',
    color: '#fff',
    fontSize: '18px !important',
    fontWeight: 400,
    lineHeight: 1.4,
    padding: '12px 16px',
    maxWidth: maxWidth,
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
    borderRadius: '6px',
  },
  [`& .MuiTooltip-arrow`]: {
    color: '#333',
    width: '12px',
    height: '12px'
  },
}));

const ToolTip = ({
  children,
  content,
  className,
  position = 'top',
  arrow = true,
  maxWidth = '400px',
  ...props
}) => {
  return (
    <CustomTooltip
      title={<span style={{ fontSize: '18px', lineHeight: '24px' }}>{content}</span>}
      arrow={arrow}
      placement={position}
      maxWidth={maxWidth}
      className={className}
      {...props}
    >
      <span className="inline-flex">{children}</span>
    </CustomTooltip>
  );
};

export default ToolTip;
